var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.target === '_blank'
    ? 'a'
    : _vm.tag,{tag:"component",staticClass:"link",class:[
        {'link--muted': _vm.muted,
        'link--underlined': _vm.underlined,
        'link--line': _vm.inLine},
        _vm.outputClass
    ],attrs:{"href":_vm.tag === 'a' ? _vm.path : '#',"to":_vm.tag === 'router-link' ? _vm.path || {} : '',"target":_vm.target}},[(_vm.text.length)?_c('span',{staticClass:"link__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }